import { render, staticRenderFns } from "./PartDetailRow.vue?vue&type=template&id=4d61f668"
import script from "./PartDetailRow.ts?vue&type=script&lang=ts&external"
export * from "./PartDetailRow.ts?vue&type=script&lang=ts&external"
import style0 from "./PartDetailRow.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports